import { render, staticRenderFns } from "./uiTextarea.vue?vue&type=template&id=133edce8&scoped=true"
import script from "./uiTextarea.vue?vue&type=script&lang=js"
export * from "./uiTextarea.vue?vue&type=script&lang=js"
import style0 from "./uiTextarea.vue?vue&type=style&index=0&id=133edce8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133edce8",
  null
  
)

export default component.exports